<div class="skeleton" [ngClass]="{'skeleton-active': show}">
    <div class="skeleton-content" *ngIf="show">
        <ul class="skeleton-paragraph">
            <li style="width: 50%;"></li>
        </ul>
    </div>
    <ng-content *ngIf="!show"></ng-content>
</div>